'use client'

import React, { createContext, useContext, useState, ReactNode } from 'react'

export type PlayListActionUiType =
  | 'create'
  | 'edit'
  | 'delete'
  | 'share'
  | 'makePublic'
  | 'whichNextAction'
  | 'standby'
export type PlayListVideoActionUiType = 'select' | 'whichNextAction' | 'createPlayList' | 'standby'

export interface TargetActionPlayListInfo {
  id: number
  title: string
  thumbnailUrl?: string
  isPublic: boolean
}

export interface TargetActionPlayListVideoInfo {
  videoId: number
  onFinish?: () => void
}

type PlaylistActionsContextType = {
  playListActionUiType: PlayListActionUiType
  playListVideoActionUiType: PlayListVideoActionUiType
  targetActionPlayListInfo: TargetActionPlayListInfo | undefined
  targetActionPlayListVideoInfo: TargetActionPlayListVideoInfo | undefined
  setPlayListActionUiType: (type: PlayListActionUiType) => void
  setPlayListVideoActionUiType: (type: PlayListVideoActionUiType) => void
  setTargetActionPlayListInfo: (info: TargetActionPlayListInfo | undefined) => void
  setTargetActionPlayListVideoInfo: (info: TargetActionPlayListVideoInfo | undefined) => void
}

const PlaylistActionsContext = createContext<PlaylistActionsContextType>({
  playListActionUiType: 'standby',
  playListVideoActionUiType: 'standby',
  targetActionPlayListInfo: undefined,
  targetActionPlayListVideoInfo: undefined,
  setPlayListActionUiType: () => {},
  setPlayListVideoActionUiType: () => {},
  setTargetActionPlayListInfo: () => {},
  setTargetActionPlayListVideoInfo: () => {},
})

export const PlaylistActionsProvider = ({ children }: { children: ReactNode }) => {
  const [playListActionUiType, setPlayListActionUiType] = useState<PlayListActionUiType>('standby')
  const [playListVideoActionUiType, setPlayListVideoActionUiType] = useState<PlayListVideoActionUiType>('standby')
  const [targetActionPlayListInfo, setTargetActionPlayListInfo] = useState<TargetActionPlayListInfo | undefined>(undefined)
  const [targetActionPlayListVideoInfo, setTargetActionPlayListVideoInfo] = useState<TargetActionPlayListVideoInfo | undefined>(undefined)

  return (
    <PlaylistActionsContext.Provider
      value={{
        playListActionUiType,
        playListVideoActionUiType,
        targetActionPlayListInfo,
        targetActionPlayListVideoInfo,
        setPlayListActionUiType,
        setPlayListVideoActionUiType,
        setTargetActionPlayListInfo,
        setTargetActionPlayListVideoInfo,
      }}
    >
      {children}
    </PlaylistActionsContext.Provider>
  )
}

export const usePlaylistActions = () => {
  return useContext(PlaylistActionsContext)
}
